// src/components/battle/SubmitSection.jsx
export default function SubmitSection({ onSubmit, disabled }) {
  return (
    <section className="mt-4">
      <button
        type="button"
        disabled={disabled}
        onClick={onSubmit}
        className="
          w-full py-3   
          text-base font-semibold tracking-wide
          rounded-2xl
          bg-[rgb(0,224,198)]
          text-white
          shadow-sm
          hover:opacity-90
          transition
          disabled:opacity-50
          disabled:cursor-not-allowed
        "
      >
        생성하기
      </button>
    </section>
  );
}
